// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1S1V6","insightsList":"newBusinessInsightsMenu_insightsList__3Umu8","active":"newBusinessInsightsMenu_active__3aSb_"};